import { Route, Routes, useNavigate } from 'react-router-dom';
import { useRecoilState, useSetRecoilState } from 'recoil';

import { FISCAL_SET } from './screensSettings';
import {
    feedbackState,
    nfcState,
    orderState,
    presentationVM,
    qrState,
    // receiptData,
    vmState,
} from './state/recoilState';

import * as Sentry from '@sentry/react';
import { useEffect, useState } from 'react';
import { Feedback, PresentationVending, VendingMachine } from './types';
import {
    checkCurrentTabUniqueness,
    cl,
    clearStoredTabData,
    cltext,
    getUrlParams,
    initUniqueTabData,
} from './utils/general';
import { trackClick, trackEvent } from './utils/tracking';

import './App.css';
import { FEEDBACK_SRC, STORAGE_KEYS, isDev } from './constants';
import {
    clearAllSavedStates,
    clearSavedOrderState,
} from './utils/stateStorage';
import AppRouter from './router/AppRouter';
import { Layout } from './components/Layout';
import {
    CompletePage,
    Error404Screen,
    NotConnectedScreen,
    NotSupportedScreen,
    WaitScreen,
} from './components/screens';
import ContactPage from './components/screens/FeedbacksScreen/ContactPage';
import WishesPage from './components/screens/FeedbacksScreen/WishesPage';
import CheckboxPage from './components/screens/FeedbacksScreen/CheckboxPage';
import SmilePage from './components/screens/FeedbacksScreen/SmilePage';

function App() {
    const [qrCode, setQrCode] = useRecoilState<string>(qrState);
    const [vm, setVm] = useRecoilState<PresentationVending>(presentationVM);
    const [order, setOrder] = useRecoilState(orderState);
    const navigate = useNavigate();

    useEffect(() => {
        const { qr, nfc, service } = getUrlParams();

        if (qr) {
            cltext('qr from url: ' + qr, 'yellow');
            // setUrlQrCode(qr);
            setQrCode(qr);
            fetchQRData(`/api/checktest?qr=${qr}`, setVm).then(() =>
                navigate(`/smilepage`)
            );
        }
    }, []);

    async function fetchQRData(url: string, setVm: any): Promise<void> {
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(response.statusText);
            }
            const result: PresentationVending = await response.json();
            setVm(result);
        } catch (error) {
            console.error('Request failed:', error);
        }
    }

    return (
        <div className="App">
            <Routes>
                <Route path="/" element={<Layout />}>
                    <Route
                        index
                        element={
                            <NotSupportedScreen
                            // onCancel={() => onCancelClickHandler('smilepage')}
                            />
                        }
                    />

                    <Route
                        path="/smilepage"
                        element={
                            <SmilePage
                                onCancel={() => console.log('smilepage')}
                            />
                        }
                    />
                    <Route
                        path="/checkboxpage"
                        element={
                            <CheckboxPage
                                onCancel={() => console.log('checkboxpage')}
                            />
                        }
                    />
                    <Route
                        path="/contactpage"
                        element={
                            <ContactPage
                                onCancel={() => console.log('contactpage')}
                            />
                        }
                    />
                    <Route
                        path="/completepage"
                        element={
                            <CompletePage
                            //onRepeatPurchase={onRepeatPurchaseClickHandler}
                            />
                        }
                    />
                    <Route
                        path="/notconnected"
                        element={
                            <NotConnectedScreen
                                onRepeatPurchase={() => {
                                    console.log('not connected');
                                }}
                            />
                        }
                    />

                    <Route path="*" element={<Error404Screen />} />
                </Route>
            </Routes>
        </div>
    );
}

export default App;
